import React from "react";
import { Spin, Typography } from "antd";

interface LoadingSpinnerProps {
  size?: "small" | "default" | "large";
  message?: string;
  centered?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "large",
  message = "Loading...",
  centered = true,
}) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: centered ? "center" : "flex-start",
      padding: "50px",
      minHeight: centered ? "200px" : "auto",
    }}
  >
    <Spin size={size} />
    <Typography.Text type="secondary" style={{ marginTop: "16px" }}>
      {message}
    </Typography.Text>
  </div>
);
